import { Container, Link } from "@mui/material"

import './notificationPage.css';
import role_selection from './role_selection.png';
import current_vouches from './current_vouches.png';
import notification_channel from './notification_channel.png'

export const NotificationPage = () => {
  return (
    <Container>
      <h2>Steps to get notifications</h2>
      <ol>
        <li>Join this discord: <Link href='https://discord.gg/eXFNNa3z7X'>https://discord.gg/eXFNNa3z7X</Link></li>
        <li>Head to the #welcome channel</li>
        <li>Select the zones you want to be notified for</li>
        <img src={role_selection} className='tutorial-image' />
        <li>Every hour the Terror Zone will change zones, and people will start vouching the new zone</li>
        <img src={current_vouches} className='tutorial-image' />
        <li>Once enough people confirm the zone, a notification will be sent in the #tz-announcements channel</li>
        <li>If you selected that zone, you will be @mentioned</li>
        <img src={notification_channel} className='tutorial-image' />
      </ol>
    </Container>
  )
}